import { useNavigate } from 'react-router-dom';
import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import WhyUsSection from './components/WhyUsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/resources';

export default function Home() {
  const navigate = useNavigate();

  const handleSearch = (query: string) => {
    navigate(`/category/study?q=${encodeURIComponent(query)}`);
  };

  return (
    <>
      <SEO
        title={`${siteInfo.name} - ${siteInfo.tagline}`}
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl="https://geiliziyuan.com"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: `${siteInfo.name} - ${siteInfo.tagline}`,
          description: siteInfo.description,
          url: 'https://geiliziyuan.com',
          isPartOf: {
            '@type': 'WebSite',
            name: siteInfo.name,
            url: 'https://geiliziyuan.com',
          },
        }}
      />

      <Navbar />

      <main>
        <HeroSection onSearch={handleSearch} />
        <CategorySection />
        <FeaturedSection />
        <WhyUsSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}